// @ts-ignore
import i18n from "@cirrus/ui-kit/src/lib/i18n.es6"
import { MuiIcon } from "@cirrus/ui-kit/src"
import { styled } from "@mui/material"
import React from "react"
import { useTableContext } from "../../provider"

const StyledWrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  placeContent: "center",
  marginTop: "65px",
  position: "relative",
  zIndex: 1,

  "& [class*=MuiSvgIcon]": {
    width: "100px",
    height: "100px",
    marginBottom: "24px",
    opacity: .26,
    color: "#000000"
  }
})

const Title = styled("div")({
  fontWeight: 700,
  fontSize: "17px",
  color: "#757575"
})

const Text = styled("div")({
  fontSize: "14px",
  color: "#757575",
  lineHeight: "24px"
})

export const NoFilteredItems = () => {

  const ctx = useTableContext()

  return <StyledWrapper>
    <MuiIcon.SearchOff />

    <Title
      dangerouslySetInnerHTML={
        { __html: ctx.props.noFilteredItemsText || i18n("General:NoFilteredItems") }
      } />

    <Text
      dangerouslySetInnerHTML={
        { __html: ctx.props.noFilteredItemsDesc || i18n("General:NoFiltersResults") }
      } />
  </StyledWrapper>
}
